import React from "react";
import { Button, Icon } from "react-onsenui";
import { getReagent } from "../../services/megamix";
import { queryHexColors } from "../../services/megamixUtils";

const queryWidth = "50px";

export const style = {
  addQueryButton: {
    borderRadius: "5px",
    height: "40px",
    width: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "10px",
    background: "white",
    marginTop: "0px"  
  },
  editQueryContainer: {
    flex: 1,
    flexGrow: 1,
    position: "relative"
  },
  editQueryButton: {
    borderRadius: "5px",
    textShadow: "2px 2px 6px rgba(0,0,0,1)",
    height: "44px",
    fontWeight: "bold",
    // height: queryWidth,
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  editQueryDeleteButton: {
    position: "absolute",
    // right: -5,
    // top: -5
  }
};

export default class QueryButton extends React.Component {
  renderAddQuery() {
    const { onClick, noQueries } = this.props;
    const className = noQueries ? "pulsate-fwd" : null;
    return (
      <div className={className}>
        <Button style={style.addQueryButton} onClick={onClick.bind(this)}>
        <Icon icon="fa-plus" size={20} style={{ WebkitTextStroke: '3px white' }} />
        </Button>
      </div>
    );
  }

  renderEditQuery() {
    const { query, queryIndex, onClick, onDeleteClick, queryEditMode } = this.props;
    const hexArray = queryHexColors(query);
    const editQueryButtonStyle = {
      ...style.editQueryButton,
      background:
        hexArray.length > 1
          ? `linear-gradient(to right, ${hexArray})`
          : hexArray
    };
    const className = queryEditMode ? "animate-pulse-opacity" : "";
    return (
      <div style={style.editQueryContainer}>
        <Button
          onClick={onClick.bind(this)}
          style={editQueryButtonStyle}
          className={className}
        >
          { getReagent(query.reagentId).fullName }
        </Button>

        {!(queryIndex === 0 && query.colorIds.length === 0) &&
          <Button
            className="query-button-delete"
            onClick={onDeleteClick.bind(this)}
          >
            <Icon icon="fa-remove" size={10} />
          </Button>
        }
      </div>
    );
  }

  render() {
    const { query } = this.props;
    if (query.reagentId == null) {
      return this.renderAddQuery();
    }
    return this.renderEditQuery();
  }
}
